import type { RouteRecordRaw } from 'vue-router';

import { wrapRuntimeImport } from '@/shared/helpers/async.helpers';

import Detect from './screens/detect.vue';

export const WorkstationRoutes: RouteRecordRaw[] = [
    {
        name: 'workstation:detect',
        path: 'detect',
        component: Detect,
        meta: { public: true }
    },
    {
        // In-app first screen, shown inside the ZynoWorkstation webview: choose
        // between entering a code or signing in, and enter the code. Public so it
        // is reachable before any sign-in (the code path is preprovisioned).
        name: 'workstation:start',
        path: 'start',
        component: wrapRuntimeImport(() => import('./screens/start.vue')),
        meta: { public: true, minimalSidebar: true }
    },
    {
        // In-browser login + configure. Native opens a real browser here because
        // OAuth/SSO can't run in the embedded webview. NOT public, so the normal
        // login view shows first; once signed in this renders the name/location/
        // type form. Native reaches it as /zw/register?h=<handshake>&p=<port>.
        name: 'workstation:register',
        path: 'register',
        component: wrapRuntimeImport(() => import('./screens/register.vue')),
        meta: { minimalSidebar: true }
    }
];
